export default __webpack_public_path__ + "static/kingsley-92fc2244059ede16a7850502cdb5eb77.svg";